var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("新增会员")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                attrs: {
                  model: _vm.infoForm,
                  rules: _vm.rules,
                  "label-position": "right",
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: "会员名称", prop: "name" },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "490px" },
                      attrs: {
                        maxlength: "10",
                        "show-word-limit": "",
                        placeholder: "请输入会员名称",
                      },
                      model: {
                        value: _vm.infoForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "name", $$v)
                        },
                        expression: "infoForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: "有效期", prop: "expirationDate" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.infoForm.expirationDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "expirationDate", $$v)
                          },
                          expression: "infoForm.expirationDate",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "一个月", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "三个月", value: "3" },
                        }),
                        _c("el-option", {
                          attrs: { label: "一年", value: "12" },
                        }),
                        _c("el-option", {
                          attrs: { label: "永久", value: "0" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "margin-right": "12px",
                        },
                      },
                      [_vm._v("购买价格")]
                    ),
                    _c("el-input", {
                      staticStyle: { width: "160px", position: "relative" },
                      attrs: {
                        placeholder: "请输入价格",
                        size: "mini",
                        oninput:
                          "value=value.replace(/^\\D*([0-9]\\d*\\.?\\d{0,2})?.*$/,'$1')",
                      },
                      model: {
                        value: _vm.infoForm.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "price", $$v)
                        },
                        expression: "infoForm.price",
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          left: "496px",
                          top: "2px",
                          "font-size": "14px",
                          color: "#cccccc",
                        },
                      },
                      [_vm._v("元")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: "会员介绍页", prop: "introduce" },
                  },
                  [
                    _c("quill-editor", {
                      ref: "myQuillEditor",
                      staticClass: "editor",
                      attrs: { options: _vm.editorOption },
                      model: {
                        value: _vm.infoForm.introduce,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "introduce", $$v)
                        },
                        expression: "infoForm.introduce",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "bottom",
                        staticStyle: { display: "none" },
                      },
                      [
                        _c("el-upload", {
                          ref: "uploadicon",
                          staticClass: "centerImg",
                          attrs: {
                            action: " ",
                            "list-type": "picture-card",
                            "auto-upload": false,
                            "on-change": _vm.handleAvatarChangeIcon,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "margin-bottom": "20px",
                    },
                    attrs: { label: "会员状态", prop: "status" },
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.infoForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "status", $$v)
                          },
                          expression: "infoForm.status",
                        },
                      },
                      [_vm._v("启用")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "0" },
                        model: {
                          value: _vm.infoForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "status", $$v)
                          },
                          expression: "infoForm.status",
                        },
                      },
                      [_vm._v("禁用")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            { attrs: { type: "warning" }, on: { click: _vm.toBack } },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitFn } },
            [_vm._v("确认")]
          ),
          _c("div", { staticStyle: { height: "20px" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }